import { FormattersTypes } from '@/services/types/formatter'
// @ts-ignore
import metricsFormatTypes from 'public/shared-reports/metrics-format';
import { FORMATS_MAP } from '@/views/formatters';


export default ({ vtag, component, data, key, ctx }: FormattersTypes) => {
  component.tag = 'span';

  return vtag(
    'div',
    {
      style: {
        'display': 'flex',
        'justify-content': 'end'
      }
    },
    [
      vtag('ui-tooltip-icon', {
        props: {
          preset: 'help',
        },
        class: 'report-cost-tooltip-icon',
      },ctx.t('To update the cost BeMob is synced with the source every 60 min')),
      FORMATS_MAP[metricsFormatTypes[key]]({ vtag, component, data, key, ctx }),
    ]
  )
}
